import { default as ServicesPage } from "../components/Services";

const Services = () => {
  return <ServicesPage />;
};

export default Services;
